import { mainApi } from "config";
import { getProgress, IProgressState } from "infrastructure/helpers/common";
import { getClientFor } from "infrastructure/http";
import { IApiError } from "ui/shared/models/common";

import { ITokenItem } from "../Messages.state";

export interface IMessagesUploadResponseError {
  message: string;
  property?: string;
}

export interface IMessagesUploadResponseItem {
  uniqueId: string;
  messageId: string;
  tokens: ITokenItem[];
  text: string;
  error: IApiError;
}

const getApiProvider = () => {
  return {
    uploadMessages: async (file: File, onProgress: (currentProgress: IProgressState) => void): Promise<IMessagesUploadResponseItem[]> => {
      const config = {
        onUploadProgress: function(progressEvent) {
          onProgress(getProgress(progressEvent.loaded, progressEvent.total));
        }
      };

      const formData = new FormData();
      formData.append("file", file);

      return (await getClientFor(mainApi.name).post<IMessagesUploadResponseItem[]>("/messages/upload", formData, config)).data;
    }
  };
};

export const messagesUploadApi = getApiProvider();
